import { defineComponent, reactive, computed, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { useStore } from 'vuex';
import _ from 'lodash';
import { SettingTable, SettingTableRow, BaseSlider, Tooltip } from '@hems/component';
import { Helper } from '@hems/util';
import { useGenType } from '@hems/util/src/composable';
import { ENERGY_POLICY } from '@hems/util/src/constant';
export default defineComponent({
    name: 'EnergyBackupSettingPvModuleGen3SmartModuleGen2',
    components: {
        SettingTable,
        SettingTableRow,
        BaseSlider,
        Tooltip,
    },
    props: {
        modelValue: {
            type: Object,
            default: () => ({ battery_backup_soc: 0 }),
        },
        editable: {
            type: Boolean,
            default: false,
        },
        currentEnergyControl: {
            type: String,
            required: true,
        },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
        const { t } = useI18n();
        const store = useStore();
        const state = reactive({
            data: { ...props.modelValue },
            show: true,
            deviceId: store.state.user.ownDeviceId,
        });
        const { isACSystem } = useGenType();
        const isStormCoverActivated = computed(() => {
            return !!(store.state.device.siteConfiguration?.hasHub &&
                isACSystem &&
                props.currentEnergyControl === ENERGY_POLICY.STORM_COVER);
        });
        const valueRange = {
            battery_backup_soc: { min: 0, max: 100 },
        };
        const description = computed(() => `${valueRange.battery_backup_soc.min} ~ ${valueRange.battery_backup_soc.max} %, ${t('message.5_per_incre')}`);
        watch(() => state.data.battery_backup_soc, () => {
            emit('update:modelValue', _.pickBy(state.data, (v) => !Helper.isNull(v)));
        });
        return {
            state,
            valueRange,
            description,
            isStormCoverActivated,
        };
    },
});
